import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import QuickAccess from './QuickAccess';

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* Header */}
        <header className="app-header">
          <div className="header-inner">
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div
                style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '10px',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                }}
              >
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="#005caa" />
                  <polygon points="10,8 16,12 10,16" fill="#ffffff" />
                </svg>
              </div>

              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <h1 style={{ fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-0.02em', margin: 0 }}>
                    BigBlueButton Recordings
                  </h1>
                  <span className="brand-badge">
                    by <a href="https://bigbluebutton.host" target="_blank" rel="noreferrer">BigBlueButton.Host</a>
                  </span>
                </div>
                <p style={{ fontSize: '0.85rem', color: '#e0f2fe', margin: '2px 0 0 0', opacity: 0.9 }}>
                  Instant BigBlueButton Recording Viewer, MP4 Video Downloader & Caption Manager
                </p>
              </div>
            </div>

            <nav style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <a
                href="https://bigbluebutton.host/plans/"
                target="_blank"
                rel="noreferrer"
                style={{ color: '#ffffff', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 600, opacity: 0.9 }}
              >
                Managed Hosting
              </a>
              <a
                href="https://bigbluebutton.host/integrations/"
                target="_blank"
                rel="noreferrer"
                style={{ color: '#ffffff', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 600, opacity: 0.9 }}
              >
                Integrations
              </a>
              <a
                href="https://bigbluebutton.host/contact/"
                target="_blank"
                rel="noreferrer"
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  color: '#ffffff',
                  padding: '5px 14px',
                  borderRadius: '20px',
                  textDecoration: 'none',
                  fontSize: '0.825rem',
                  fontWeight: 600,
                  border: '1px solid rgba(255,255,255,0.3)'
                }}
              >
                Contact Support
              </a>
            </nav>
          </div>
        </header>

        {/* Main Application */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<QuickAccess />} />
          </Routes>
        </main>

        {/* Footer matching BigBlueButton.Host */}
        <footer className="app-footer">
          <div className="footer-inner">
            <div className="footer-top">
              <div style={{ maxWidth: '420px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '0.75rem' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="#005caa" />
                    <polygon points="10,8 16,12 10,16" fill="#ffffff" />
                  </svg>
                  <strong style={{ fontSize: '1.05rem', color: 'var(--slate-900)' }}>BigBlueButton.Host</strong>
                </div>
                <p style={{ fontSize: '0.825rem', color: 'var(--slate-600)', lineHeight: 1.6 }}>
                  Fully managed BigBlueButton hosting plans, dedicated servers, LMS integrations (Moodle, Canvas, WordPress), custom branding, and 24/7 technical support.
                </p>
              </div>

              <div>
                <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--slate-800)', marginBottom: '0.5rem' }}>
                  Hosting & Solutions
                </strong>
                <ul className="footer-links" style={{ flexDirection: 'column', gap: '0.4rem', fontSize: '0.825rem' }}>
                  <li><a href="https://bigbluebutton.host/plans/" target="_blank" rel="noreferrer">Our Plans & Pricing</a></li>
                  <li><a href="https://bigbluebutton.host/integrations/" target="_blank" rel="noreferrer">LMS API Integrations</a></li>
                  <li><a href="https://bigbluebutton.host/demo/" target="_blank" rel="noreferrer">Interactive Demo</a></li>
                  <li><a href="https://bbbroom.live" target="_blank" rel="noreferrer">BBBRoom.Live</a></li>
                </ul>
              </div>

              <div>
                <strong style={{ display: 'block', fontSize: '0.85rem', color: 'var(--slate-800)', marginBottom: '0.5rem' }}>
                  Support & Policies
                </strong>
                <ul className="footer-links" style={{ flexDirection: 'column', gap: '0.4rem', fontSize: '0.825rem' }}>
                  <li><a href="https://bigbluebutton.host/faq/" target="_blank" rel="noreferrer">Frequently Asked Questions</a></li>
                  <li><a href="https://bigbluebutton.host/blog/view-recordings/" target="_blank" rel="noreferrer">Recording Setup Guide</a></li>
                  <li><a href="https://bigbluebutton.host/uptime-sla/" target="_blank" rel="noreferrer">Uptime SLA</a></li>
                  <li><a href="https://bigbluebutton.host/privacy-and-policy/" target="_blank" rel="noreferrer">Privacy Policy</a></li>
                </ul>
              </div>
            </div>

            <div className="footer-bottom">
              <div>
                Powered by <strong>Bymond Private Limited</strong> • CIN: U51909WB2019PTC234607
              </div>
              <div style={{ fontSize: '0.75rem', color: 'var(--slate-400)' }}>
                Disclaimer: BigBlueButton Host is not associated with or endorsed by BigBlueButton Inc.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
